export const listOvertimes = overtimes => {
    if(overtimes && overtimes.length) {
        let otString = ''
        overtimes.forEach(ot=> {
            otString += `${ot.type.name[0]}: ${ot.hrs}hrs,   `
        })
        return  otString
    }
}
